import moment from 'moment-timezone';

export const getFirstDate = ({ days, fromDate }) => {
  const currentWeekDay = Number(moment(fromDate).isoWeekday());
  const firstWeekDay =
    Number(days.sort().find((d) => Number(d) >= currentWeekDay)) ||
    Number(days.sort()[0]);
  const increment =
    firstWeekDay + (firstWeekDay < currentWeekDay ? 7 : 0) - currentWeekDay;
  return moment(fromDate).add(increment, 'day').format('YYYY-MM-DD');
};
